<form #loginForm="ngForm" (ngSubmit)="onLogin()">
  <p class="text-danger" *ngIf="error">{{error}}</p>
  <div class="row">
    <div class="input col col-sm-12 mb-3">
      <span>
        <i class="icon icon-mail ml-4 pl-2" aria-hidden="true"></i>
        <input name="email" class="email form-control border-0" type="text" [(ngModel)]="user.email" [attr.placeholder]='"Email"'>
      </span>
    </div>
  </div>

  <div class="row">
    <div class="input col col-sm-12 mb-3">
      <span>
        <i class="icon icon-lock ml-4 pl-2" aria-hidden="true"></i>
        <input name="password" class="password form-control border-0" type="password" [(ngModel)]="user.password" [attr.placeholder]='"Password"'>
      </span>
    </div>
  </div>

  <div class="row">
    <div class=	"col col-sm-12 mb-4">
      <button type="submit" class="login btn border-0 blue">
        <span *ngIf="!showSpinner" >LOGIN</span>
        <span *ngIf="showSpinner" ><i class="icon fa fa-circle-o-notch fa-spin"></i></span>
      </button>
    </div>
  </div>

  <div class="row">
    <div class=	"remember-me col col-sm-6 p-0 pl-5" (click)='setRememberMe()'>
      <img src='{{user.rememberMe ? "/assets/img/selected.svg" : "/assets/img/rectangle-4.svg"}}' alt="Show All">
      <span class='ml-3'>Remember me</span>
    </div>
    <!-- <div class=	"col col-sm-6 p-0 pr-4">
      <a type="button" class="forgot btn btn-sm float-right text-right" href="https://pwd-mgr.uefastaging.ch/PMUser">
        <span>Forgot Password?</span>
      </a>
    </div> -->
  </div>
</form>
